import script from "./MedicineList.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicineList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__